import m from "../../geodata/es2015/czechRepublicLow";
window.am4geodata_czechRepublicLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/czechRepublicLow.js
// module id = null
// module chunks = 